import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { userLoginActionFn } from "../redux/actions/userAuthAction";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

// @mui icons
import LoginIcon from "@mui/icons-material/Login";

import { Box, Typography, Input, Button } from "@mui/material";
// Images
import bgImage from "../assets/images/bg-login.jpeg";
import rodhiflix_darklogo from "../assets/images/logos/rodhiflix_darklogo.png";
import bhetamana from "../assets/vetumnata_logo.jpeg";

function Login() {
  const [rememberMe, setRememberMe] = useState(false);
  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, user, error } = useSelector((state) => state.userStore);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("ADMIN");
  // console.log(username, password, role);

  const formValidation = () => {
    if (username == null || username === undefined || username === "") {
      toast.warning("Username is required!");
      return false;
    }
    if (password == null || password === undefined || password === "") {
      toast.warning("Password is required!");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    const isFormValid = formValidation();
    if (isFormValid) {
      const isSuccess = await dispatch(
        userLoginActionFn({ username, password, role })
      );
      if (isSuccess) {
        toast.success("Login Successful");
        navigate("/dashboard");
      }
    }
  };

  useEffect(() => {
    if (error) {
      error.message === undefined
        ? toast.error("Something Went Wrong!")
        : toast.error(` Login Failed. ${error.message}`);
    }
  }, [error]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "10% 0 0 0",
      }}
    >
      <ToastContainer />
      <Card
        sx={{
          background: "#2A0F41",
          borderRadius: "1rem",
          minWidth: 320,
          boxShadow: "0 2px 2px 0.2rem rgba(85, 108, 116, 0.25)",
        }}
      >
        <Box
          variant="gradient"
          // bgColor="info"
          // coloredShadow="info"
          borderRadius="lg"
          mx={2}
          mt={-2}
          p={5}
          mb={1}
          textAlign="center"
        >
          <Box
            component="img"
            sx={{
              height: 120,
              width: 140,
              maxHeight: { xs: 320, md: 200 },
              maxWidth: { xs: 300, md: 220 },
            }}
            src={bhetamana}
            alt="bhetamana"
            shadow="lg"
          ></Box>
          <Typography variant="h4" fontWeight="medium" color="white" mt={1}>
            Admin Dashboard Login!
          </Typography>
        </Box>

        <Box pt={0} pb={3} px={3}>
          <Box component="form" role="form">
            {/* <TextField variant="standard" label="Username" fullWidth />
            <TextField variant="standard" label="Password" fullWidth /> */}
            <Box mb={2}>
              <Input
                onChange={(e) => setUsername(e.target.value)}
                value={username}
                type="email"
                label="Email"
                placeholder="Username"
                fullWidth
              />
            </Box>
            <Box mb={2}>
              <Input
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                type="password"
                label="Password"
                placeholder="Password"
                fullWidth
              />
            </Box>
            <Box display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <Typography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Remember me
              </Typography>
            </Box>
            <Box mt={4} mb={4}>
              <Button
                onClick={handleSubmit}
                startIcon={<LoginIcon />}
                variant="gradient"
                style={{
                  borderRadius: "1rem",
                  boxShadow: "0px 0px 1px 1px #a6a9be",
                  backgroundColor: "#2b8784",
                  color: "black",
                  height: "1.5rem",
                }}
                fullWidth
              >
                Login
              </Button>
            </Box>
            {/* <Box mt={3} mb={1} textAlign="center">
              <Typography variant="button" color="text">
                Don&apos;t have an account?{" "}
                <Typography
                  component={Link}
                  to="/authentication/sign-up"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Sign up
                </Typography>
              </Typography>
            </Box> */}
          </Box>
        </Box>
      </Card>
    </div>
  );
}

export default Login;

// card: #111c27

// app_bg: #0b1014

// hightlight: #2b8784
